import { connect } from 'react-redux';
import ItemDetails from './ItemDetails';
import cookiesFactory from '../../../../../../../base/cookies-factory';

const mapStateToProps = ({
  estimateBuilder: { uiState, entities, windowLabel },
}, { itemId }) => {
  const {
    items: {
      byId: {
        [itemId]: {
          attributes: itemAttributes,
          label,
          subtotal,
          itemProduct,
          retail,
        },
      },
    },
    estimates: {
      byId: {
        [uiState.selectedEstimate]: {
          isLockedOrOrdered,
          attributes: { isMandi },
        },
      },
    },
  } = entities;

  const isInternalUser = cookiesFactory.isInternalUser();

  return {
    isMandi,
    name: label,
    isLockedOrOrdered,
    retail,
    subtotal,
    itemId,
    itemProduct,
    attributes: itemAttributes,
    isInternalUser,
    windowLabel,
  };
};

export default connect(mapStateToProps)(ItemDetails);
